import * as React from 'react';
import {
  IconInfrastructureChildPlayground16,
  IconInfrastructurePet16,
  IconInfrastructureFastService16,
  IconInfrastructureFitness16,
  IconInfrastructureOffice16,
  IconInfrastructureHospital16,
  IconInfrastructurePool16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSpa16,
  IconInfrastructureSupermarket16,
  IconInfrastructureParking16,
  IconSafetyBarrier16,
  IconSafetySecurity16,
  IconComfortReception16,
  IconSafetySecurityParking16,
  IconSafetyCloseArea16,
  IconInfrastructureSchool16,
  IconInfrastructureCommercialObject16,
  IconInfrastructureKid16,
  IconInfrastructureSportsground16,
  IconSafetyFireExtinguisher16,
  IconSafetySignal16,
  IconSafetyOutdoorCamera16,
} from '@cian/ui-kit-design-tokens/icons';
import {
  EShortInfrastructureType,
  EParkingItemType,
  ESecurityItemType,
} from '../types/newbuilding/specificationsDetailed';

export const DETAILED_SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EShortInfrastructureType.Children]: <IconInfrastructureChildPlayground16 />,
  [EShortInfrastructureType.Commerce]: <IconInfrastructureCommercialObject16 />,
  [EShortInfrastructureType.Dogs]: <IconInfrastructurePet16 />,
  [EShortInfrastructureType.Domestic]: <IconInfrastructureFastService16 />,
  [EShortInfrastructureType.Fitness]: <IconInfrastructureFitness16 />,
  [EShortInfrastructureType.Kindergarten]: <IconInfrastructureKid16 />,
  [EShortInfrastructureType.Offices]: <IconInfrastructureOffice16 />,
  [EShortInfrastructureType.Polyclinic]: <IconInfrastructureHospital16 />,
  [EShortInfrastructureType.Pool]: <IconInfrastructurePool16 />,
  [EShortInfrastructureType.Recreation]: <IconInfrastructureChildPlayground16 />, //
  [EShortInfrastructureType.Restaurant]: <IconInfrastructureRestaurant16 />,
  [EShortInfrastructureType.School]: <IconInfrastructureSchool16 />,
  [EShortInfrastructureType.Spa]: <IconInfrastructureSpa16 />,
  [EShortInfrastructureType.Sport]: <IconInfrastructureSportsground16 />,
  [EShortInfrastructureType.Supermarket]: <IconInfrastructureSupermarket16 />,
  [EParkingItemType.Guest]: <IconInfrastructureParking16 />,
  [EParkingItemType.Standalone]: <IconInfrastructureParking16 />,
  [EParkingItemType.Underground]: <IconInfrastructureParking16 />,
  [ESecurityItemType.Access]: <IconSafetyBarrier16 />,
  [ESecurityItemType.AroundTheClock]: <IconSafetySecurity16 />,
  [ESecurityItemType.Camera]: <IconSafetyOutdoorCamera16 />,
  [ESecurityItemType.Concierge]: <IconComfortReception16 />,
  [ESecurityItemType.Fire]: <IconSafetyFireExtinguisher16 />,
  [ESecurityItemType.Parking]: <IconSafetySecurityParking16 />,
  [ESecurityItemType.Perimetr]: <IconSafetyCloseArea16 />,
  [ESecurityItemType.Signal]: <IconSafetySignal16 />,
};
